import { 
    ContactMeButton, 
    GhButton, 
    LinkedinButton, 
    DiscordButton,
    EmailButton,
    List,
    CTAContainer,
    ListContainer,
    DownloadCVButton,
    DownloadIcon,
} from "./styles";
import cvFile from "../../assets/Curriculo TI.pdf";

export function ContactList() {
    return (
        <List>
            <CTAContainer>
                <ContactMeButton>
                    <a href="https://www.linkedin.com/in/davidesdras/" target="_blank" rel="noreferrer">
                        fale comigo
                    </a>
                </ContactMeButton>
                <DownloadCVButton>
                    <a href={cvFile} download>
                        <DownloadIcon />
                        <p>
                            download CV
                        </p> 
                    </a>
                </DownloadCVButton>
            </CTAContainer>
            <ListContainer>
                <ul>
                    <li>
                        <a href="https://github.com/DavidEsdrs" target="_blank" rel="noreferrer">
                            <GhButton size={"2.4rem"} />
                        </a>
                    </li>
                    <li>
                        <a href="https://www.linkedin.com/in/davidesdras/" target="_blank" rel="noreferrer">
                            <LinkedinButton size={"2.4rem"} />
                        </a>
                    </li>
                    <li>
                        <a href="https://discordapp.com/channels/@me/dav#3959" target="_blank" rel="noreferrer">
                            <DiscordButton size={"2.4rem"} />
                        </a>
                    </li>
                    <li>
                        <a href="mailto:davidesdrasfdev@gmail.com" target="_blank" rel="noreferrer">
                            <EmailButton size={"2.4rem"} />
                        </a>
                    </li>
                </ul>
            </ListContainer>
        </List>
    )
}